import { render, staticRenderFns } from "./GSchoolClassesEntryModal.vue?vue&type=template&id=db6731d2&scoped=true&"
import script from "./GSchoolClassesEntryModal.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClassesEntryModal.vue?vue&type=script&lang=ts&"
import style0 from "./GSchoolClassesEntryModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6731d2",
  null
  
)

export default component.exports